import { ClbButton } from "@celebration/react/ClbButton/ClbButton";
import type { ButtonProps } from "@components/contracts/Button.types";
import type React from "react";

export const CelebrationButton: React.FC<ButtonProps> = ({
  content,
  ...props
}) => (
  <ClbButton
    {...props}
    type="button"
    style={content ? { justifyContent: content } : undefined}
  />
);
